import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ModalComponent } from '@wkda/styleguide';
import cx from 'classnames';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { CookieSelector } from './CookieSelector';
import { SelectionModeButton } from './SelectionModeButton';
import { useGDPRBannerContext } from './useGDPRBanner';
import styles from './GDPRBanner.module.scss';
import './main.scss';
const focusTrapOptions = { initialFocus: `.${styles.submitButton}` };
export function GDPRBanner({ content, onClose, className }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const formRef = useRef(null);
    const onCloseRef = useRef(onClose);
    const { isInSelectionMode, clickHandler } = useCookiesConfigurationMode(formRef);
    const { submitAll } = useGDPRBannerContext();
    function submitAllHandler(e) {
        e.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
            submitAll();
        }
    }
    function clickSelectHandler(e) {
        if (isInSelectionMode && !isSubmitted) {
            setIsSubmitted(true);
        }
        if (!isSubmitted) {
            clickHandler(e);
        }
        e.preventDefault();
    }
    useEffect(() => {
        if (typeof onClose === 'function') {
            onCloseRef.current = onClose;
        }
    }, [onClose]);
    useEffect(() => {
        setIsOpen(true);
        return () => {
            if (typeof onCloseRef.current === 'function') {
                onCloseRef.current();
            }
        };
    }, []);
    return (_jsx(_Fragment, { children: _jsx(ModalComponent, { isOpen: isOpen, focusTrapOptions: focusTrapOptions, children: _jsx(GDPRBannerForm, { ref: formRef, className: className, content: content, isInSelectionMode: isInSelectionMode, submitAllHandler: submitAllHandler, clickSelectHandler: clickSelectHandler }) }) }));
}
export const GDPRBannerForm = forwardRef(function GDPRBannerForm({ className, content, isInSelectionMode = false, submitAllHandler = () => { }, clickSelectHandler = () => { }, }, formRef) {
    return (_jsx("form", { ref: formRef, action: "/v1/gdpr-preferences/", method: "POST", children: _jsxs("div", { className: cx(styles.banner, className), children: [_jsx("h1", { className: styles.title, children: content.title }), _jsx("p", { className: styles.info, dangerouslySetInnerHTML: {
                        __html: isInSelectionMode ? content.selectionInfo : content.info,
                    } }), isInSelectionMode ? (_jsx(CookieSelector, { content: {
                        essential: content.essential,
                        analytical: content.analytical,
                        marketing: content.marketing,
                    } })) : null, _jsx(Button, { className: cx(styles.submitButton, {
                        [styles.submitButtonInSelectionMode]: isInSelectionMode,
                    }), variant: "secondary", onClick: submitAllHandler, "data-qa-selector": "gdpr-banner-accept-all-button", children: content.button }), _jsx(SelectionModeButton, { content: content.secondaryButton, onClick: clickSelectHandler, isInSelectionMode: isInSelectionMode }), _jsx("input", { type: "hidden", defaultValue: getCurrentUrlValue(), name: "currentUrl", className: styles.hidden })] }) }));
});
function useCookiesConfigurationMode(formRef) {
    const [isInSelectionMode, setIsSelectionMode] = useState(false);
    const { submit, submitAll, isEverythingSelected } = useGDPRBannerContext();
    return {
        isInSelectionMode,
        clickHandler: (e) => {
            if (isInSelectionMode) {
                e.preventDefault();
                if (isEverythingSelected) {
                    submitAll();
                }
                else {
                    submit().then(() => {
                        formRef?.current?.submit();
                    });
                }
            }
            return setIsSelectionMode(true);
        },
    };
}
function getCurrentUrlValue() {
    return typeof window === 'undefined' ? '' : window.location.href;
}
